import React, { useEffect, useState } from 'react';
import {
  Card, Form, Row, Col, Button,
} from 'react-bootstrap';

// import api from '../../api';

import _ from 'lodash';
import MaterialTable, { MTableBody } from 'material-table';
import {
  TableCell, TableFooter, TableHead, Paper,
} from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import { History } from '@material-ui/icons';
import Required from '../Required';
import { floatRenderer } from '../../services/formatSvc';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../helpers/table';
import { renderEditMoneyComponent } from '../../pages/index/Shared';
import { MonetaryFloatInput } from '../common/MonetaryFloatInput';
import useAPI from '../../hooks/useAPI';
import useToast from '../../hooks/useToast';
import api from '../../api';

function range(start, end) {
  return start && end ? Array((end < start ? start : end) - start + 1).fill().map((_, idx) => start + idx) : [];
}

function flattenSums(buyKvrs, yearRange) {
  return (buyKvrs || []).map((k) => {
    const row = {
      id: k.id,
      costKvrId: k.costKvrId,
      costKvr: k.costKvr,
    };
    yearRange.forEach((y) => {
      row[y] = k.sums && k.sums.length > 0
        ? (k.sums.find((s) => s.year === y) || {}).draftSum
        : null;
    });
    return row;
  }).flat();
}

export default function BuyKvrsSf({ buy, onChange, readOnly }) {
  const api = useAPI();
  const addToast = useToast();

  const [editMode, setEditMode] = useState(false);

  const [kvrs, setKvrs] = useState([]);
  useEffect(async () => {
    const ks = await api.get('/mng/cost/kvrs');
    setKvrs(ks); // у закупок СФ нет скрытых КВР
  }, []);

  // #region Modify items
  const handleKvrAdd = (kvrId) => {
    const selectedKvr = kvrs.find((et) => et.id === kvrId);
    const newBuyKvr = {
      buyId: buy.id, costKvrId: selectedKvr.id, costKvr: selectedKvr, sums: [],
    };
    if (!buy.buyKvrs.find((k) => k.costKvrId === selectedKvr.id)) {
      onChange((buy.buyKvrs || []).concat([newBuyKvr]), 'buyKvrs');
    }
    setEditMode(false);
  };
  const handleKvrDelete = async (kvrId) => {
    if (!buy.id || await validateKvrDelete(kvrId)) {
      onChange([...buy.buyKvrs.filter((r) => r.costKvrId !== kvrId)], 'buyKvrs');
    }
  };
  const validateKvrDelete = async (costKvrId) => {
    const sums = await api.get(`/buys/${buy.id}/kvrs/${costKvrId}/sums?approved=true`);
    if (!sums || sums.error) {
      addToast.error('Не удалось запросить отчетные суммы из утвержденной версии закупки');
      return false;
    } if (sums.find((s) => s.acceptedSum || s.contractSum || s.paymentSum)) {
      addToast.error('Невозможно удалить КВР, по которому есть отчетные суммы из 1С');
      return false;
    }
    return true;
  };

  /**
   * Проверить, не оказалась ли измененная сумма по данной КВР (для закупок СФ - за все года) меньше акцептованной суммы по той же КВР за все года
   * @param {number} costKvrId ID КВР
   * @param {number} sum Новая стоимость за все года
   * @returns
   */
  const validateSumChange = async (costKvrId, sum) => {
    if (buy.id) {
      const res = await api.post(`/buys/${buy.id}/kvrs/0/sums/0/remainder`, {
        buyId: buy.id,
        costKvrId,
        sum,
      });
      if (res.error) return false;
      if (res.remainder < -0.005) {
        addToast.error('Введенная оценочная стоимость меньше суммы акцепта. Обратитесь в ПФУ для коррекции суммы акцепта или увеличьте оценочную стоимость');
        return false;
      }
    }
    return true;
  };

  const updateYearRangeSums = (years, buyKvr, row) => {
    years.forEach(y => {
      let yearSum = buyKvr.sums.find(s => s.year === y);
      if (!yearSum) {
        buyKvr.sums.push({ year: y, draftSum: row[y.toString()] });
      } else yearSum.draftSum = row[y.toString()];
    });
  }

  const handleSumsChange = async (row) => {
    const buyKvrsCopy = [...buy.buyKvrs];
    const buyKvrCopy = buyKvrsCopy.find((k) => k.costKvrId === row.costKvrId);
    const oldSum = _.sumBy(buyKvrCopy.sums, 'draftSum');
    const yearRange = range(buy.year || new Date().getFullYear(), new Date().getFullYear());
    if (oldSum) {
      const newSumAllYears = yearRange.reduce((agg, y) => agg += (row[y.toString()] ?? 0), 0);
      if (await validateSumChange(row.costKvrId, newSumAllYears)) {
        updateYearRangeSums(yearRange, buyKvrCopy, row);
      }
    } else {
      updateYearRangeSums(yearRange, buyKvrCopy, row);
    }
    onChange(buyKvrsCopy, 'buyKvrs');
  };
  // #endregion

  const columns = [
    {
      title: 'Код статьи', field: 'costKvr.num', cellStyle: { textAlign: 'center' }, editable: 'never',
    },
    { title: 'Наименование', field: 'costKvr.name', editable: 'never' },
  ].concat(range(buy.year || new Date().getFullYear(), new Date().getFullYear())
    .map((y) => ({
      title: y.toString(),
      field: y.toString(),
      render: (rowData) => <div align="center">{floatRenderer(rowData[y])}</div>,
      // editable: !readOnly,//todo
      editComponent: (props) =>
      // let value = props.value && props.value.find(v => v.year === buy.year);
        <MonetaryFloatInput value={props.value || 0} onChange={props.onChange} table />
      ,
    })));

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">Оценочная стоимость закупки</Card.Header>

      <Card.Body className="p-4">
        <Row className="mb-4">
          <Col md={3}>
            <Button variant="primary" hidden={editMode || readOnly} onClick={() => setEditMode(true)}>Добавить КВР</Button>
          </Col>
          <Form.Group as={Col} md="12" hidden={!editMode || readOnly}>
            <Form.Label>Код вида расхода (КВР)</Form.Label>
            <Form.Control
              as="select"
              placeholder="Выберите КВР из списка"
              value=""
              onChange={(e) => handleKvrAdd(parseInt(e.target.value))}
            >
              <option key="blankChoice" hidden value />
              {kvrs
                .filter((k) => !buy.buyKvrs || !buy.buyKvrs.find((bk) => bk.costKvrId === k.id))
                .map((k) => (
                  <option key={k.id} value={k.id}>
                    {k.num}
                    {' '}
                    {k.name}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Row>
        <MaterialTable
          options={modifyDefaultOptions({
            actionsColumnIndex: 0,
            filtering: false,
            search: false,
            paging: false,
            toolbar: false,
          })}
          icons={tableIconsModified}
          localization={localization}
          columns={columns}
          data={flattenSums(buy.buyKvrs, range(buy.year || new Date().getFullYear(), new Date().getFullYear()))}
          editable={{
            isEditable: (rowData) => !readOnly,
            isDeletable: (rowData) => !readOnly,
            onRowUpdate: (newData, oldData) =>
              new Promise(async (resolve, reject) => {
                await handleSumsChange(newData);
                resolve();
              }),
            onRowDelete: (oldData) =>
              new Promise(async (resolve, reject) => {
                await handleKvrDelete(oldData.costKvrId);
                resolve();
              }),
          }}
                    // actions={[
                    //     {
                    //         custom: true,
                    //         hidden: false,
                    //         icon: () =><History style={{color: '#0D6EFD'}}/>,
                    //         tooltip: 'История изменений',
                    //         onClick: (data) => {
                    //             setHistoryModalReport({ id: data.id, num: data.num, name: data.name })
                    //         }
                    //     },
                    // ]}
          components={{
            Header: (props) => (
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={tableHeaderStyling}>Действ.</TableCell>
                  <TableCell colSpan={2} align="center" style={tableHeaderStyling}>Код вида расхода (КВР)</TableCell>
                  <TableCell colSpan={range(buy.year || new Date().getFullYear(), new Date().getFullYear()).length || 1} align="center" style={tableHeaderStyling}>Сумма (руб.)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={tableHeaderStyling}> </TableCell>
                  <TableCell align="center" style={tableHeaderStyling}>Код статьи</TableCell>
                  <TableCell align="center" style={tableHeaderStyling}>Наименование</TableCell>
                  {range(buy.year, new Date().getFullYear()).map((y) => <TableCell key={y} align="center" style={tableHeaderStyling}>{y}</TableCell>)}
                </TableRow>
              </TableHead>
            ),
            Body: (props) => (
              <>
                <MTableBody {...props} />
                <TableFooter>
                  <TableRow>
                    <TableCell />
                    <TableCell colSpan={2}> Итого:</TableCell>
                    {range(buy.year || new Date().getFullYear(), new Date().getFullYear())
                      .map((y) => (
                        <TableCell key={y} align="center">
                          {floatRenderer((buy.buyKvrs || []).map((k) => k.sums.filter((s) => s.year === y)
                            .map((s) => s.draftSum)).flat()
                            .reduce((prev, item) => prev + item, 0))}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableFooter>
              </>
            ),
          }}
        />
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
const tableHeaderStyling = {
  fontSize: 12, background: 'white', color: '#000000de',
};
